import React from "react";
import { MainLayout } from "../layouts/main";

import Login from "../pages/authenticate/login";
import { links } from "../constants/links";
import ResendPhoneNumber from "../pages/authenticate/resend-phone-number";
import ListRewards from "../pages/list-rewards";
import Engage from "../pages/engage";
import UseReward from "../pages/use-reward";
import UseReward2 from "../pages/use-reward-v2";
import VerifyToken from "../pages/authenticate/verify-token";
import GetURL from "../pages/authenticate/get-url";
import VerifyQrCode from "../pages/authenticate/verify-qr-code";
import DAGC from "../pages/dagc";
import DOWNLOAD from "../pages/download";
import ENGAGED from "../pages/engaged";
import COUPON from "../pages/coupon";
import OTPInsertPhone from "../pages/otp-insert-phone";
import OTPInsertOTP from "../pages/otp-insert-otp";
import OTPPageExpired from "../pages/otp-page-expired";
import OTPMaxAttemptReached from "../pages/otp-max-attempt-reached";
import OTPPhoneNumberAlreadyRegistered from "../pages/otp-phone-number-already-registered";
import SMART_RETAIL_STATUS from "../pages/smart-retail-status";
import SMART_RETAIL_ERROR from "../pages/smart-retail-error";
import VALIDATE_ENGAGE_FIRST from "../pages/validate-engage-first";
import CampaignStatus from "../pages/campaign-status-page";
import VersionDisplay from "../pages/version";
import CAMPAIGN_LIMIT_ERROR from "../pages/campaign-limit-error";
import SEReceipt from "../pages/se-receipt";
import LoyaltySubmit from "../pages/loyalty-submit";
import MultiCoupons from "../pages/multi-coupons";
import { List } from "../pages/List";
import Paypayconsent from "../pages/pay-pay-consent";
import LineLiffAuth from "../pages/authenticate/login/line-liff/LineLiffAuth";
import PaypayCoupon from "../pages/pay-pay-coupon";

export interface IRoute {
  restricted?: boolean;
  layout?: React.ComponentType;
  title?: string;
  children: any;
  path: string;
}

const privateRoutes: IRoute[] = [
  {
    children: <MultiCoupons />,
    path: links.MULTI_COUPONS,
    layout: MainLayout,
  },
  {
    children: <ListRewards />,
    path: links.EARN_PAGE,
    layout: MainLayout,
  },
  {
    children: <UseReward />,
    path: links.USE_REWARD,
    layout: MainLayout,
  },
  {
    children: <UseReward2/>,
    path: links.USE_REWARD_V2,
    layout: MainLayout,
  },
  {
    children: <DAGC />,
    path: links.DAGC,
  },
  {
    children: <DOWNLOAD />,
    path: links.DOWNLOAD,
  },
  {
    children: <ENGAGED />,
    path: links.ENGAGED_PAGE,
  },
  {
    children: <OTPInsertPhone />,
    path: links.OTP_INSERT_PHONE_NUMBER,
  },
  {
    children: <OTPInsertOTP />,
    path: links.OTP_INSERT_OTP,
  },
  {
    children: <OTPPageExpired />,
    path: links.OTP_PAGE_EXPIRED,
  },
  {
    children: <OTPMaxAttemptReached />,
    path: links.OTP_MAX_ATTEMPT_REACHED,
  },
  {
    children: <OTPPhoneNumberAlreadyRegistered />,
    path: links.OTP_PHONE_NUMBER_ALREADY_REGISTERED,
  },
];
const publicRoutes: IRoute[] = [
  {
    children: <Engage />,
    path: links.ENGAGE_PAGE
  },
  {
    children: <VerifyQrCode />,
    path: "/",
  },
  {
    children: <Login />,
    path: links.LOGIN,
    restricted: true
  },
  {
    children: <LineLiffAuth />,
    path: links.LIFF_LOGIN,
  },
  {
    children: <ResendPhoneNumber />,
    path: links.RESEND,
  },
  {
    children: <VerifyToken />,
    path: links.VERIFY,
  },
  {
    children: <GetURL/>,
    path: links.GETURL
  },
  {
    children: <COUPON />,
    path: links.COUPON
  },
  {
    children: <SMART_RETAIL_STATUS />,
    path: links.SMART_RETAIL_STATUS
  },
  {
    children: <SMART_RETAIL_ERROR />,
    path: links.SMART_RETAIL_ERROR
  },
  {
    children: <VALIDATE_ENGAGE_FIRST />,
    path: links.VALIDATE_ENGAGE_FIRST
  },
  {
    children: <CampaignStatus/>,
    path: links.CAMPAIGN_STATUS
  },
  {
    children: <VersionDisplay/>,
    path: links.VERSION
  },
  {
    children: <CAMPAIGN_LIMIT_ERROR />,
    path: links.CAMPAIGN_LIMIT_ERROR,
  },
  {
    children: <SEReceipt/>,
    path: links.SE_RECEIPT
  },
  {
    children: <LoyaltySubmit/>,
    path: links.LOYALTY_SUBMIT
  },
  {
    children: <Paypayconsent/>,
    path: links.PAY_PAY_CONSENT
  },
  {
    children: <PaypayCoupon/>,
    path: links.PAY_PAY_COUPON
  }
];
const noLayoutRoutes: IRoute[] = [
  {
    children: <List />,
    path: links.LIST_PAGE
  },
];
interface IConfigRoutes {
  appRoutes: IRoute[];
  isPrivate?: boolean;
  layout?: React.FC;
}

export const configRoutes: IConfigRoutes[] = [
  {
    appRoutes: privateRoutes,
    isPrivate: true,
    layout: MainLayout,
  },
  {
    appRoutes: noLayoutRoutes,
  },
  {
    appRoutes: publicRoutes,
    layout: MainLayout,
  },
];
